// Header & Footer Editor Controller
// Simplified Stimulus controller that bridges to Vue components
// Legacy version preserved in header_footer_editor_controller.js.legacy

import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import HeaderFooterEditor from '~/javascript/components/header_footer_editor/index.vue'

export default class extends Controller {
  static values = {
    websiteId: String,
    headerContent: { type: Object, default: {} },
    footerContent: { type: Object, default: {} },
    headerSettings: { type: Object, default: {} },
    footerSettings: { type: Object, default: {} },
    headerTemplate: { type: String, default: 'navbar_service' },
    footerTemplate: { type: String, default: 'footer_columns' },
    services: { type: Array, default: []},
    serviceAreas: { type: Array, default: []},
    headerTemplates: { type: Array, default: []},
    footerTemplates: { type: Array, default: []},
    businessName: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
    previewUrl: { type: String, default: '' },
    canDeploy: { type: Boolean, default: false },
    apiEndpoints: { type: Object, default: {} }
  }

  connect() {
    // Mount Vue application
    this.vue = createApp(HeaderFooterEditor, {
      websiteId: this.websiteIdValue,
      initialHeaderContent: this.headerContentValue,
      initialFooterContent: this.footerContentValue,
      initialHeaderSettings: this.headerSettingsValue,
      initialFooterSettings: this.footerSettingsValue,
      initialHeaderTemplate: this.headerTemplateValue,
      initialFooterTemplate: this.footerTemplateValue,
      services: this.servicesValue,
      serviceAreas: this.serviceAreasValue,
      headerTemplates: this.headerTemplatesValue,
      footerTemplates: this.footerTemplatesValue,
      businessName: this.businessNameValue,
      logoUrl: this.logoUrlValue,
      previewUrl: this.previewUrlValue,
      canDeploy: this.canDeployValue,
      apiEndpoints: this.apiEndpointsValue
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    if (this.vue) {
      this.vue.unmount()
      this.vue = null
    }
  }
}
